
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 47","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.484 2.261a3 3 0 00-4.39.2L16 3.75V10h7V4.589a2 2 0 00-.599-1.427l-.917-.901z","fill":"#fff"}}),_c('path',{attrs:{"d":"M16 3.75l1.094-1.29a3 3 0 014.39-.199l.917.901A2 2 0 0123 4.59V10m-7-6.25V10m0-6.25V10m0 0v17.728c0 .956.677 1.78 1.614 1.964l1.391.273a.997.997 0 00.355.006l1.963-.322A2 2 0 0023 27.677V10m-7 0h7","stroke":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M40 27.625C40 38.671 31.046 47 20 47S0 38.67 0 27.625c0-5.67 2.36-10.79 6.151-14.43.83-.796 2.015-1.064 3.142-.838.8.161 1.414.804 1.538 1.61l.065.421c.219 1.424-.383 2.824-1.339 3.901A13.076 13.076 0 006.25 27c0 7.249 5.876 13.125 13.125 13.125S32.5 34.249 32.5 27c0-3.196-1.142-6.125-3.04-8.401-1.058-1.268-1.64-2.947-1.155-4.526l.082-.266a2 2 0 011.583-1.385l.768-.128c1.121-.187 2.284.096 3.105.883A19.94 19.94 0 0140 27.625z","fill":"#fff"}})])
          )
        }
      }
    